import React from 'react';
import PropTypes from 'prop-types';
import ModalComponent from 'components/common/ModalComponent';
import SelectComponent from 'components/common/SelectComponent';

const TimingDataModal = ({ isOpen, onClose, onSave, initialData, workersList }) => {
  if (!isOpen) return null;

  const onSaveTimingDataHandeler = formData => {
    onSave({
      ...formData,
      workerIds: formData.workerIds.map(id => Number(id))
    });
  };

  return (
    <ModalComponent
      title="Create Timing"
      isOpen={isOpen}
      onClose={onClose}
      initialData={initialData}
      onSave={onSaveTimingDataHandeler}
    >
      {({ formData, handleChange }) => (
        <div className="grid grid-cols-2 gap-5 pb-4">
          <div>
            <label className="block text-sm font-medium">Timing Type *</label>
            <SelectComponent
              name="timingType"
              value={formData.timingType}
              onChange={handleChange}
              className="w-full border rounded p-2"
            >
              <option value="" disabled>
                Select...
              </option>
              <option value="1">Start</option>
              <option value="2">End</option>
            </SelectComponent>
          </div>
          <div>
            <label className="block text-sm font-medium">Workers *</label>
            <select
              name="workerIds"
              value={formData.workerIds}
              onChange={e => {
                const selectedValues = Array.from(e.target.selectedOptions, option => option.value);
                handleChange({
                  target: { name: 'workerIds', value: selectedValues }
                });
              }}
              multiple
              className="w-full border rounded p-2 min-h-10"
            >
              {workersList.map(worker => (
                <option key={worker.id} value={worker.id}>
                  {worker.name}
                </option>
              ))}
            </select>
          </div>
          <div>
            <label className="block text-sm font-medium">Date</label>
            <input
              type="date"
              name="date"
              value={formData.date}
              onChange={handleChange}
              className="w-full border rounded p-2"
            />
          </div>
          <div>
            <label className="block text-sm font-medium">Time *</label>
            <input
              type="time"
              name="time"
              value={formData.time}
              onChange={handleChange}
              className="w-full border rounded p-2"
            />
          </div>
        </div>
      )}
    </ModalComponent>
  );
};

TimingDataModal.propTypes = {
  isOpen: PropTypes.bool.isRequired,
  onClose: PropTypes.func.isRequired,
  onSave: PropTypes.func.isRequired,
  initialData: PropTypes.object,
  workersList: PropTypes.arrayOf(PropTypes.object)
};

export default TimingDataModal;
